import input1 from '/public/siteImages/iOSTheme/inputType/input1.png';
import input2 from '/public/siteImages/iOSTheme/inputType/input2.png';
import input3 from '/public/siteImages/iOSTheme/inputType/input3.png';
import input4 from '/public/siteImages/iOSTheme/inputType/input4.png';

export {
    input1,
    input2,
    input3,
    input4,
}
